'use client';

import { Filter } from 'lucide-react';
import { FindingCard } from './FindingCard';
import type { Finding } from './types';
import styles from '@/components/audit/ProReportResults.module.css';

interface FindingsGridProps {
  findings: Finding[];
  filteredFindings: Finding[];
  expandedCards: Set<number>;
  activeFilter: string | null;
  onToggleCard: (index: number) => void;
  onClearFilter: () => void;
  findingRefs: React.MutableRefObject<Map<string, HTMLElement>>;
}

export function FindingsGrid({
  findings,
  filteredFindings,
  expandedCards,
  activeFilter,
  onToggleCard,
  onClearFilter,
  findingRefs,
}: FindingsGridProps) {
  return (
    <section className={styles.findingsSection}>
      <div className={styles.findingsHeader}>
        <div>
          <h2 className={styles.sectionTitle}>Detailed Findings</h2>
          <p className={styles.findingsSubtitle}>
            {activeFilter
              ? `Showing ${filteredFindings.length} ${activeFilter} issues`
              : `All ${findings.length} issues with recommendations`}
          </p>
        </div>

        {activeFilter && (
          <button className={styles.clearFilter} onClick={onClearFilter}>
            <Filter size={14} />
            Clear filter
          </button>
        )}
      </div>

      <div className={styles.findingsGrid}>
        {filteredFindings.map((finding, index) => (
          <FindingCard
            key={finding.id || index}
            ref={(el) => {
              if (el) findingRefs.current.set(String(index), el);
            }}
            finding={finding}
            isExpanded={expandedCards.has(index)}
            onToggle={() => onToggleCard(index)}
          />
        ))}
      </div>
    </section>
  );
}
